// The app is locked to a single dark theme that matches tickahead.com (navy
// canvas, cobalt accent, teal-green up, coral down, a navy chart plot). There
// is no in-app light/dark/system option — theme.css has one palette, so no
// data-theme stamp is needed; the OS colour scheme is ignored (D-141).

import { storageSet } from "./storage.js";
import { darkChartTheme, type ChartTheme } from "./chart-render.js";

/** Call once per page (popup / chart window / snip). The dark palette is the
 * only one in theme.css; we just record the browser scheme for the toolbar. */
export async function applyStoredTheme(): Promise<void> {
  document.documentElement.setAttribute("data-theme", "dark");
  reportBrowserColorScheme();
}

/** The browser toolbar follows the OS/browser colour scheme (NOT our in-app
 * theme), and the service worker can't read a media query — so each page
 * records `prefers-color-scheme` here, and the worker tints the toolbar
 * icon's idle grey to stay visible on a light OR dark toolbar. */
export const BROWSER_SCHEME_KEY = "browserColorScheme";
function reportBrowserColorScheme(): void {
  const mq = window.matchMedia("(prefers-color-scheme: dark)");
  const write = (dark: boolean) => void storageSet(BROWSER_SCHEME_KEY, dark ? "dark" : "light");
  write(mq.matches);
  mq.addEventListener("change", (e) => write(e.matches));
}

/** The chart palette — the dark (navy) theme, matching the site, so drawing-tool
 * ink stays light-on-dark. */
export function chartThemeColors(): ChartTheme {
  return darkChartTheme;
}
